import textComponent from './text';

export default function text(picasso) {
  picasso.component('text', textComponent);
}
